import { render, staticRenderFns } from "./createChildAuth.vue?vue&type=template&id=08a47678&scoped=true&"
import script from "./createChildAuth.vue?vue&type=script&lang=js&"
export * from "./createChildAuth.vue?vue&type=script&lang=js&"
import style0 from "./createChildAuth.vue?vue&type=style&index=0&id=08a47678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a47678",
  null
  
)

export default component.exports